import { useForm } from 'react-hook-form';
import { Input } from '../shared/Input';
import { Button } from '../shared/Button';

interface DatosLogin {
  usuario: string;
  password: string;
}

interface Props {
  onSubmit: (datos: DatosLogin) => void;
  enviando: boolean;
  error?: string;
}

export function LoginForm({ onSubmit, enviando, error }: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<DatosLogin>();

  return (
    <form onSubmit={handleSubmit(onSubmit)} data-testid="admin-login-form" className="flex flex-col gap-4">
      <Input
        label="Usuario"
        placeholder="admin@sacrafts.com"
        error={errors.usuario?.message}
        {...register('usuario', { required: 'El usuario es requerido' })}
      />
      <Input
        label="Contraseña"
        type="password"
        placeholder="••••••••"
        error={errors.password?.message}
        {...register('password', { required: 'La contraseña es requerida' })}
      />
      {error && <p className="text-xs text-danger" role="alert">{error}</p>}
      <Button type="submit" disabled={enviando} data-testid="admin-login-submit-button">
        {enviando ? 'Ingresando…' : 'Iniciar sesión'}
      </Button>
    </form>
  );
}
